<template>
    <div class="card-body shadow p-3 bg-dark rounded">
        <h1>로그인</h1>
        <p class="text-muted">로그인 해주세요</p>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <i class="icon-user"></i>
                </span>
            </div>
            <input class="form-control" type="text" placeholder="ID" v-model="userId" maxlength="20">
        </div>
        <div class="input-group mb-4">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <i class="icon-lock"></i>
                </span>
            </div>
            <input class="form-control" type="password" placeholder="Password" v-model="userPass" maxlength="20"
                @keyup.enter="login">
        </div>
        <div class="row">
            <div class="col-6 mb-1">
                <div class="form-check">
                    <!--
                    <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="isSaveUserId">
                    <label class="form-check-label" for="defaultCheck1">
                        사용자 ID 저장
                    </label>
                 -->
                </div>
            </div>
        </div>
        <div style="display: flex;flex-direction: row-reverse;">
            <button class="btn btn-primary px-4" type="button" @click="login">
                <i class="icon-login"></i>
                로그인</button>
        </div>
        <!-- <div class="col-6 text-right">
			<button class="btn btn-link px-0" type="button" @click="goRequestPermission">관리자에게 권한요청</button>
		</div> -->
    </div>
</template>

<script>
import request from '../../../lib/request'
import utils from '../../../lib/utils'

const INDEX_PAGE_URL = '/pages/index.html',
    USER_ID_STORAGE_KEY = 'userId',
    ROLETYPE_STORAGE_KEY = 'roleType',
    REQUEST_PERMISSION_PAGE_ROUTE_NAME = 'requestPermission'

export default {
    name: 'login',
    data() {
        return {
            userId: '',
            userPass: '',
            isSaveUserId: false,
            roleType: ''
        }
    },
    watch: {
        isSaveUserId(val, oldVal) {
            this.$log.debug('사용자 ID 저장 value: ', val)

            try {
                if (val) {
                    // 사용자 ID 저장
                    this.saveUserId()
                } else {
                    // 사용자 ID 삭제
                    this.removeUserId()
                }
            } catch (err) {
                this.$log.error('사용자 ID 삭제를 실패했습니다.', err)
            }
        }
    },
    methods: {
        login() {
            // if (this.userId && this.userId !== '') {
            //     if (this.userPass && this.userPass !== '') {
            this.$log.debug('로그인 요청 userId: ', this.userId, ', userPass: ', this.userPass)

            request.user.login({
                userId: this.userId,
                userPass: this.userPass
            })
                .then(result => {
                    let err
                    console.log("result", result);
                    if (result.data.result === 200) {
                        this.$log.debug('로그인 성공 ', result.data)
                        this.roleType = result.data.userInfo.roleType
                        sessionStorage.setItem('userId', result.data.userInfo.userId)
                        sessionStorage.setItem('roleType', result.data.userInfo.roleType)
                        // index 페이지로 이동
                        location.href = INDEX_PAGE_URL
                    } else {
                        alert(result.data.resultMsg)
                        err = new Error(result.data.resultMsg)
                        err.resultData = result.data

                        //throw err
                    }
                })
                .catch(err => {
                    this.$log.error('로그인 실패 ', err)
                    alert('로그인에 실패했습니다.')
                })
            //      } else {
            //          alert('PASSWORD를 입력하세요')
            //      }
            //  } else {
            //      alert('ID를 입력하세요')
            //  }
        },
        goRequestPermission() {
            this.$router.push(REQUEST_PERMISSION_PAGE_ROUTE_NAME)
        },
        getSaveUserId() {
            return utils.cookie.getCookie(USER_ID_STORAGE_KEY)
        },
        saveUserId() {
            utils.cookie.addCookie(USER_ID_STORAGE_KEY, this.userId)
            utils.cookie.addCookie(ROLETYPE_STORAGE_KEY, this.roleType)
            this.roleType
        },
        removeUserId() {
            utils.cookie.removeCookie(USER_ID_STORAGE_KEY)
            utils.cookie.removeCookie(ROLETYPE_STORAGE_KEY)
        }
    },
    created() {
        if (localStorage.getItem("errorString")) {
            alert(localStorage.getItem("errorString"));
        }

        let userId = utils.cookie.getCookie(USER_ID_STORAGE_KEY)
        let roleType = utils.cookie.getCookie(ROLETYPE_STORAGE_KEY)

        if (userId) {
            this.userId = userId
            this.isSaveUserId = true
            this.roleType = roleType
        }

        localStorage.clear();
    }
}
</script>
